import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, AlertTriangleIcon } from 'lucide-react';
const failures = [{
  title: 'The 1,200-calorie diet',
  description: 'It spikes your cortisol — the stress hormone — which signals your body to store fat. Your body hears "danger" and holds on tighter. You don\'t lose weight. You lose energy, milk supply, and the will to continue.'
}, {
  title: 'The intense ab workouts',
  description: 'If you have diastasis recti — the abdominal separation that affects the majority of postpartum women — those crunches are actively pulling your core apart. The "poochy belly" you\'re desperate to fix gets worse with every rep. Nobody told you.'
}, {
  title: 'The "bounce back in 6 weeks" promise',
  description: "That's a marketing slogan, not a biological reality. It was designed to sell you something, not help you heal. And when it doesn't happen — when your body doesn't cooperate with an arbitrary timeline — you're left with the devastating conclusion that you failed."
}];
export function FailureSection() {
  return <section className="bg-white px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-40">
      <div className="mx-auto max-w-4xl" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-10" data-id="element-42">
          <h2 className="mb-6 font-serif text-4xl font-bold text-[#2D2D2D] sm:text-5xl" data-id="element-43">
            Here's what nobody in the fitness industry wants to admit:
          </h2>
          <p className="font-serif text-2xl italic text-[#D4603A]" data-id="element-44">
            Every program that's failed you was designed for someone else's
            body.
          </p>
          <p className="mt-4 font-sans text-xl text-[#2D2D2D]/80" data-id="element-45">
            Not your body. Not your hormones. Not your reality.
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-46">
          {failures.map((failure, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col sm:flex-row gap-6 rounded-2xl bg-[#FBF7F0] p-8 shadow-sm" data-id="element-47">
              <div className="flex-shrink-0" data-id="element-48">
                <XCircleIcon className="h-8 w-8 text-[#D4603A]" data-id="element-49" />
              </div>
              <div data-id="element-50">
                <h3 className="mb-3 font-serif text-2xl font-bold text-[#2D2D2D]" data-id="element-51">
                  {failure.title}
                </h3>
                <p className="font-sans text-lg leading-relaxed text-[#2D2D2D]/80" data-id="element-52">
                  {failure.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mt-12 rounded-2xl border-2 border-[#D4603A]/20 bg-[#FFF5F0] p-10 text-center" data-id="element-53">
          <AlertTriangleIcon className="mx-auto mb-6 h-12 w-12 text-[#D4603A]" data-id="element-54" />
          <h3 className="mb-4 font-serif text-3xl font-bold text-[#2D2D2D]" data-id="element-55">
            You didn't fail. You were set up to fail.
          </h3>
          <p className="mb-8 font-sans text-xl leading-relaxed text-[#2D2D2D]/80" data-id="element-56">
            The fitness industry handed a postpartum woman a manual written for
            a 22-year-old athlete and said "follow this."
          </p>
          <div className="inline-block rounded-full bg-white px-8 py-4 shadow-md" data-id="element-57">
            <p className="font-sans text-lg font-bold text-[#D4603A]" data-id="element-58">
              85% of mothers abandon their health goals in the first three
              months.
            </p>
          </div>
          <p className="mt-6 font-sans text-lg text-[#2D2D2D]/80" data-id="element-59">
            Not because they lack discipline. Because they're fighting their own
            biology with the wrong tools.
          </p>
        </motion.div>
      </div>
    </section>;
}